import React, { useRef, useCallback, useEffect } from "react";
import axios from "axios";
import { useLenis } from "lenis/react";
import { Nav } from "../components/landing/Nav";
import { Hero } from "../components/landing/Hero";
import { HowItWorks } from "../components/landing/HowItWorks";
import { ThreeSided } from "../components/landing/ThreeSided";
import { FoundingArtist } from "../components/landing/FoundingArtist";
import { TrustMarquee } from "../components/landing/TrustMarquee";
import { Footer } from "../components/landing/Footer";
import { ChatWidget } from "../components/ChatWidget";
import { useSeo } from "../lib/seo";

export default function Landing() {
  const foundingRef = useRef(null);
  const lenis = useLenis();
  useSeo("/");

  useEffect(() => {
    // Cookieless, privacy-friendly pageview. Best-effort — never blocks the page.
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/track`, { event: "pageview" })
      .catch(() => {});
  }, []);

  const scrollToApply = useCallback(() => {
    // Target the form card itself (not the whole section) so the first field is
    // visible on both the desktop two-column and the stacked mobile layouts.
    const el = document.getElementById("apply-card") || foundingRef.current;
    if (!el) return;
    // Focus the first field only AFTER the scroll settles, without triggering a
    // second browser scroll (preventScroll) — otherwise it races Lenis momentum.
    const focusFirstField = () =>
      document.querySelector('[data-testid="apply-name"]')?.focus?.({ preventScroll: true });

    if (lenis) {
      // Compute an absolute target from the live DOM so the scroll is correct
      // regardless of Lenis' internal position state, and force it through.
      const targetY = el.getBoundingClientRect().top + window.scrollY - 100;
      lenis.scrollTo(targetY, { duration: 1.1, force: true, onComplete: focusFirstField });
    } else {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      setTimeout(focusFirstField, 900);
    }
  }, [lenis]);

  return (
    <div className="grain relative" style={{ backgroundColor: "#0E0A16" }}>
      <Nav />
      <main>
        <Hero onApply={scrollToApply} />
        <TrustMarquee />
        <HowItWorks />
        <ThreeSided />
        <FoundingArtist ref={foundingRef} onApply={scrollToApply} />
      </main>
      <Footer />
      <ChatWidget onApply={scrollToApply} />
    </div>
  );
}
